import { render, staticRenderFns } from "./SubscriptionStandard.vue?vue&type=template&id=180e6a8b&"
import script from "./SubscriptionStandard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports